import { FC } from "react";
// 常量
import { DragChangeSizes, DragSizeProps, MoveData, SizeChangeData, SizeType } from "./interface";
import { checkChangeSize, getChangeBottom, getChangeLeft, getChangeRight, getChangeTop, } from "./util";

/** 改变大小 */
const DragSize: FC<DragSizeProps> = props => {
  const { 
    width: gridWidth, height: gridHeight, left: itemLeft, top: itemTop, column: itemColumn, row: itemRow,
    minColumn = 1, minRow = 1, grid, itemRef, otherGridUseData, onChangeStart, onChangeEnd, onChangeMove,
  } = props;
  /** 鼠标按下 */
  const handleMouseDown = (downEvent: React.MouseEvent<HTMLDivElement, MouseEvent>, type: SizeType[]) => {
    const itemDom = itemRef.current;
    if (!itemDom) return;
    const startData: MoveData = {
      x: downEvent.clientX,
      y: downEvent.clientY,
    };
    const itemStyle = window.getComputedStyle(itemDom, null);
    const { width, height, left, top, } = itemStyle;
    const changeData: SizeChangeData = { left: 0, top: 0, column: 0, row: 0, };
    const handleMouseMove = (moveEvent: any) => {
      moveEvent.preventDefault();
      onChangeStart();
      const changeParams: DragChangeSizes = {
        moveX: moveEvent.clientX - startData.x,
        moveY: moveEvent.clientY - startData.y,
        width: gridWidth,
        height: gridHeight,
        left: itemLeft,
        top: itemTop,
        column: itemColumn,
        row: itemRow,
        grid: grid,
        minColumn: minColumn,
        minRow: minRow,
      };
      if (type.includes('top')) {
        const changeTop = getChangeTop(changeParams);
        /** 大小改变后是否会和其他项重合 */
        const isCoincidence = checkChangeSize({name: 'change', left: itemLeft, top: itemTop + changeTop, column: itemColumn, row: itemRow - changeTop}, otherGridUseData, grid);
        if (!isCoincidence) {
          changeData.top = changeTop;
          changeData.row = -changeTop;
          const newTop = window.parseFloat(top) + changeParams.moveY;
          const newHeight = window.parseFloat(height) - changeParams.moveY;
          // 最大top定位值
          const maxTop = ((itemTop + itemRow - minRow) * (gridHeight + 8)) + 8;
          itemDom.style.top = `${newTop > maxTop ? maxTop : newTop}px`;
          // 最小高度
          const minHeight = (minRow * (gridHeight + 8)) - 8;
          itemDom.style.height = `${newHeight < minHeight ? minHeight : newHeight}px`;
        }
      }
      if (type.includes('right')) {
        const changeColumn = getChangeRight(changeParams);
        /** 大小改变后是否会和其他项重合 */
        const isCoincidence = checkChangeSize({name: 'change', left: itemLeft, top: itemTop, column: itemColumn + changeColumn, row: itemRow}, otherGridUseData, grid);
        if (!isCoincidence) {
          changeData.column = changeColumn;
          const newWidth = window.parseFloat(width) + changeParams.moveX;
          // 最小宽度
          const minWidth = (minColumn * (gridWidth + 8)) - 8;
          itemDom.style.width = `${newWidth < minWidth ? minWidth : newWidth}px`;
        }
      }
      if (type.includes('bottom')) {
        const changeRow = getChangeBottom(changeParams);
        /** 大小改变后是否会和其他项重合 */
        const isCoincidence = checkChangeSize({name: 'change', left: itemLeft, top: itemTop, column: itemColumn, row: itemRow + changeRow}, otherGridUseData, grid);
        if (!isCoincidence) {
          changeData.row = changeRow;
          const newHeight = window.parseFloat(height) + changeParams.moveY;
          // 最小高度
          const minHeight = (minRow * (gridHeight + 8)) - 8;
          itemDom.style.height = `${newHeight < minHeight ? minHeight : newHeight}px`;
        }
      }
      if (type.includes('left')) {
        const changeLeft = getChangeLeft(changeParams);
        /** 大小改变后是否会和其他项重合 */
        const isCoincidence = checkChangeSize({name: 'change', left: itemLeft + changeLeft, top: itemTop, column: itemColumn - changeLeft, row: itemRow}, otherGridUseData, grid);
        if (!isCoincidence) {
          changeData.left = changeLeft;
          changeData.column = -changeLeft;
          const newLeft = window.parseFloat(left) + changeParams.moveX;
          const newWidth = window.parseFloat(width) - changeParams.moveX;
          const maxLeft = (itemLeft + itemColumn - minColumn) * (gridWidth + 8) + 8;
          itemDom.style.left = `${newLeft > maxLeft ? maxLeft : newLeft}px`;
          // 最小宽度
          const minWidth = (minColumn * (gridWidth + 8)) - 8; 
          itemDom.style.width = `${newWidth < minWidth ? minWidth : newWidth}px`;
        }
      }
      onChangeMove(changeData);
    };
    const handleMouseup = () => {
      onChangeEnd(changeData);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseup);
    };
    window.addEventListener('mousemove', handleMouseMove, false);
    window.addEventListener('mouseup', handleMouseup, false);
  };

  return (
    <>
      <div 
        className="resizable-handle resizable-handle-t"
        onMouseDown={event => handleMouseDown(event, ['top'])}
      ></div>
      <div 
        className="resizable-handle resizable-handle-r"
        onMouseDown={event => handleMouseDown(event, ['right'])}
      ></div>
      <div 
        className="resizable-handle resizable-handle-b"
        onMouseDown={event => handleMouseDown(event, ['bottom'])}
      ></div>
      <div 
        className="resizable-handle resizable-handle-l"
        onMouseDown={event => handleMouseDown(event, ['left'])}
      ></div>
      <div 
        className="resizable-handle resizable-handle-tr"
        onMouseDown={event => handleMouseDown(event, ['top', 'right'])}
      ></div>
      <div 
        className="resizable-handle resizable-handle-rb"
        onMouseDown={event => handleMouseDown(event, ['right', 'bottom'])}
      ></div>
      <div 
        className="resizable-handle resizable-handle-bl"
        onMouseDown={event => handleMouseDown(event, ['bottom', 'left'])}
      ></div>
      <div 
        className="resizable-handle resizable-handle-lt"
        onMouseDown={event => handleMouseDown(event, ['left', 'top'])}
      ></div>
    </>
  );
};

export default DragSize;
